import React from 'react';
import { App as AntApp } from 'antd';
import AppRouter from './AppRouter';
import { Provider } from 'react-redux';
import store from './api/redux/store';
import { SupportChatProvider } from './context/SupportChatContext';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <AntApp>
        <SupportChatProvider>
          <AppRouter />
        </SupportChatProvider>
      </AntApp>
    </Provider>
  );
};

export default App;
